import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AdminCreateCareer = () => {
  const [jobCode, setJobCode] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [location, setLocation] = useState('South Australia');
  const [jobType, setJobType] = useState('Disability Support Worker');
  const [description, setDescription] = useState('');
  
  const editorRef = useRef(null);
  const quillRef = useRef(null);
  const navigate = useNavigate();

  const locations = ['South Australia', 'Victoria', 'Queensland'];
  const jobTypes = ['Disability Support Worker', 'Other Vacancies'];

  useEffect(() => {
    if (editorRef.current && !quillRef.current) {
      quillRef.current = new Quill(editorRef.current, {
        theme: 'snow',
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['clean']
          ]
        },
        placeholder: 'Write job description...',
      });

      const editor = editorRef.current.querySelector('.ql-editor');
      editor.style.minHeight = '300px';
      
      quillRef.current.on('text-change', () => {
        setDescription(quillRef.current.root.innerHTML);
      });
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const career = {
      jobCode,
      jobTitle,
      location,
      jobType,
      description
    };

    try {
      const response = await fetch(`${BASE_URL}/api/admin/createcareer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('adminToken')}`
        },
        body: JSON.stringify(career)
      });
      if (response.ok) {
        navigate('/admin/dashboard');
      }
    } catch (error) {
      console.error('Error creating career posting:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto p-8 bg-white shadow-2xl rounded-2xl">
        <h2 className="text-4xl font-bold mb-10 text-center text-gray-800">
          Create Job Posting
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block font-medium mb-2 text-gray-700">Job Code</label>
              <input
                type="text"
                value={jobCode}
                onChange={(e) => setJobCode(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500"
                required
              />
            </div>
            <div>
              <label className="block font-medium mb-2 text-gray-700">Job Title</label>
              <input
                type="text"
                value={jobTitle}
                onChange={(e) => setJobTitle(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500"
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block font-medium mb-2 text-gray-700">Location</label>
              <select
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500"
              >
                {locations.map(loc => (
                  <option key={loc} value={loc}>{loc}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block font-medium mb-2 text-gray-700">Job Type</label>
              <select
                value={jobType}
                onChange={(e) => setJobType(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500"
              >
                {jobTypes.map(type => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <label className="block font-medium mb-2 text-gray-700">Job Description</label>
            <div ref={editorRef} className="bg-white border border-gray-300 rounded-xl"></div>
          </div>

          <button
            type="submit"
            className="w-full py-4 bg-indigo-600 text-white text-xl font-semibold rounded-xl
                     hover:bg-indigo-700 transition-all duration-200"
          >
            Post Job
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminCreateCareer;
